export const facadeBaseUrl = '/order-facade/facade-broker-api';
export const BROKERAGE_SUPPORTED_BROKERS = ['FYERS', 'BROKER_STUB'];
